import axios from 'axios';
import authHeader from './auth-header';

// const API_URL = 'http://localhost:3000/messages/';
const API_URL = 'https://api.hometender.co/auth/';

class MessagesService {
  getAll() {
    return axios
      .get(API_URL + 'all', { headers: authHeader() })
      .then(response => {
        return response.data;
      });
  }
}

export default new MessagesService();
